export default "__VITE_ASSET__c1GUF04I__"